import useCapabilities, { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";

const PAT_RESULT_VOLUME_ROLES = [ROLE.GLOBAL_ADMIN, ROLE.MEMBERSHIP_SERVICES_ADMIN] as const;

export function canViewPatResultVolume(hasGlobalAdminRole: boolean, hasMembershipServicesAdminRole: boolean): boolean {
  return hasGlobalAdminRole || hasMembershipServicesAdminRole;
}

export function usePatResultVolumeAccess() {
  const { loaded } = useCapabilities();
  const hasAllowedRole = useHasRoles([...PAT_RESULT_VOLUME_ROLES]);

  return { loaded, canView: hasAllowedRole };
}
